import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "../config/config";
import { ResponsePackage } from "../models/util.model";
import { Observable } from "rxjs";
import { F33CrudCreate } from "../models/f33.model";

@Injectable({
    providedIn: 'root',
})
export class Feeder33Service {
    private pathApi: string;
    constructor(private http: HttpClient, private config: AppConfig) {
        this.pathApi = this.config.setting['pathApi'] + 'feeder33/';
    }

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    getAllForSelect(utilityId: number | null = null): Observable<any> {
        if (utilityId) {
            return this.http.get(`${this.pathApi}getAllForSelect/${utilityId}`, { observe: 'response' });
        }
        else {
            return this.http.get(`${this.pathApi}getAllForSelect`, { observe: 'response' });
        }
    }

    getAll(dataIn: any): Observable<any> {
        return this.http.post(`${this.pathApi}getAll`, dataIn, { observe: 'response' });
    }

    save(f33: F33CrudCreate): Observable<any> {
        return this.http.post(`${this.pathApi}save`, f33, { observe: 'response' });
    }

    delete(id: number): Observable<any> {
        return this.http.delete(`${this.pathApi}delete/${id}`, { observe: 'response' });
    }

    downloadFile(dataIn: any): Observable<any> {
        return this.http.post(`${this.pathApi}downloadFile`, dataIn);
    }
}